import { RaidLobbyPlayer } from "@/providers/raid-provider";

export interface DisplayPokemon {
  // From team_preview item
  display_id: string;
  base_pokemon_name: string;
  level: number;
  
  // Player info
  username: string;
  playerId: string;
  player: RaidLobbyPlayer;
}

/**
 * Get the list of pokemons to display based on the number of players.
 * 
 * Rules:
 * - 1 player: Show first 4 pokemons
 * - 2 players: Show first 2 pokemons of each player
 * - 3 or 4 players: Show first pokemon of each player
 */
export function getRaidDisplayPokemons(
  players: Record<string, RaidLobbyPlayer | null>
): DisplayPokemon[] {
  const activePlayers = Object.values(players).filter((p): p is RaidLobbyPlayer => !!p);
  const playerCount = activePlayers.length;
  const result: DisplayPokemon[] = [];

  if (playerCount === 1) {
    // 1 player: 4 pokes
    const p = activePlayers[0];
    p.team_preview.slice(0, 4).forEach(poke => {
      result.push({ 
        ...poke, 
        username: p.username, 
        playerId: p.id,
        player: p 
      });
    });
  } else if (playerCount === 2) {
    // 2 players: 2 pokes each
    activePlayers.forEach(p => {
      p.team_preview.slice(0, 2).forEach(poke => {
        result.push({ 
          ...poke, 
          username: p.username, 
          playerId: p.id,
          player: p 
        });
      });
    });
  } else {
    // 3 or 4 players: 1 poke each
    activePlayers.forEach(p => {
      if (p.team_preview[0]) {
        result.push({ 
          ...p.team_preview[0], 
          username: p.username, 
          playerId: p.id,
          player: p 
        });
      }
    });
  }
  
  return result;
}



